import client from "../client/client";

// Billing por Stripe (user-api). Si Stripe todavía no está configurado, el backend
// responde 503 {code: "billing_not_configured"} y el caller cae al fallback (mailto).

/** Crea una sesión de Stripe Checkout para el plan. interval: "month" | "year". */
const checkout = async (plan, interval) => {
  const resp = await client.post("/user-api/billing/checkout", { plan, interval });
  return resp?.data?.url;
};

/** Crea una sesión del Customer Portal (gestionar / cancelar la suscripción). */
const portal = async () => {
  const resp = await client.post("/user-api/billing/portal", {});
  return resp?.data?.url;
};

const isNotConfigured = (error) =>
  error?.response?.status === 503 &&
  error?.response?.data?.code === "billing_not_configured";

const billingService = { checkout, portal, isNotConfigured };
export default billingService;
